import { MaterialIcons } from "@expo/vector-icons";
import { Text, TouchableOpacity, View, StyleSheet } from "react-native";
import React from "react";

const ScrollFilterItem = ({ iconName, text, isActive, onPress }) => {
    const renderIcon = () => {
        return <MaterialIcons name={iconName} size={35} color="black" />;
    };

    return (
        <>
            <TouchableOpacity
                style={styles.container}
                onPress={onPress}
            >
                {renderIcon()}

                <Text>{text}</Text>

                {isActive && <View style={styles.activeIndicator} />}
            </TouchableOpacity>
        </>
    );
}

const styles = StyleSheet.create({
    container: {
        flexDirection: 'column',
        alignItems: 'center',
        width: 100,
    },
    icon: {
        marginBottom: 5,
        color: "black",
    },
    text: {
        textAlign: 'center',
    },
    activeIndicator: {
        width: '100%',
        height: 2,
        backgroundColor: 'black',
        marginTop: 15,
    },
});

export default ScrollFilterItem;